"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignUp = exports.SignIn = void 0;
const tslib_1 = require("tslib");
const clerk_react_1 = require("@clerk/clerk-react");
const react_1 = tslib_1.__importDefault(require("react"));
const RemixOptionsContext_1 = require("./RemixOptionsContext");
const SignIn = (props) => {
    const { signInUrl } = (0, RemixOptionsContext_1.useClerkRemixOptions)();
    if (signInUrl) {
        return (react_1.default.createElement(clerk_react_1.SignIn, { routing: 'path', path: signInUrl, ...props }));
    }
    return react_1.default.createElement(clerk_react_1.SignIn, { ...props });
};
exports.SignIn = SignIn;
const SignUp = (props) => {
    const { signUpUrl } = (0, RemixOptionsContext_1.useClerkRemixOptions)();
    if (signUpUrl) {
        return (react_1.default.createElement(clerk_react_1.SignUp, { routing: 'path', path: signUpUrl, ...props }));
    }
    return react_1.default.createElement(clerk_react_1.SignUp, { ...props });
};
exports.SignUp = SignUp;
